"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = splitArrayIntoBatches;
/**
 * Splits an array into batches of the given batch size.
 * @param array Array to split into batches
 * @param batchSize The number of items in each batch
 * @returns A 2-dimensional array of T
 */
function splitArrayIntoBatches(array, batchSize) {
    const result = [];
    for (let i = 0; i < array.length; i++) {
        const batchIndex = Math.floor(i / batchSize);
        if (!result[batchIndex]) {
            result[batchIndex] = [];
        }
        result[batchIndex].push(array[i]);
    }
    return result;
}
//# sourceMappingURL=splitArrayIntoBatches.js.map